<template>
  <div>
    <BillssMonitoring :titlee="'Stuff House'">

    </BillssMonitoring>
  </div>
</template>
<script>
  import BillssMonitoring from './BillssMonitoring'

  export default {
    components: {
      BillssMonitoring,
    },
  }
</script>
